import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Megaphone, CheckCircle2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export default function LeadCapture() {
  const nav = useNavigate();
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [f, setF] = useState({ business_name: "", contact_name: "", email: "", phone: "", website: "", industry: "", objective: "", budget: "", desired_campaign: "" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/leads", f); setSent(true); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  if (sent) return (
    <div className="min-h-[100dvh] bg-[#F8FAFC] flex flex-col items-center justify-center text-center px-6" data-testid="lead-success">
      <CheckCircle2 className="text-[#16A34A]" size={48} />
      <h1 className="font-display text-3xl mt-4">Thank you! 🙌</h1>
      <p className="text-sm text-slate-500 mt-2 max-w-sm">We got your enquiry and sent a confirmation to your email. Our team will reach out shortly with placements and pricing.</p>
      <button onClick={() => nav("/advertise")} className="mt-6 bg-[#FFD700] text-slate-900 font-bold px-6 py-3 rounded-xl" data-testid="lead-to-portal">Or start self-service now →</button>
    </div>
  );

  return (
    <div className="min-h-[100dvh] bg-[#F8FAFC] px-5 py-8 max-w-md mx-auto" data-testid="lead-page">
      <button onClick={() => nav("/")} className="flex items-center gap-1 label-xs text-slate-500 mb-3"><ArrowLeft size={14} /> Home</button>
      <div className="flex items-center gap-2"><Megaphone className="text-[#FFD700]" size={26} /><h1 className="font-display text-3xl">Promote Your Business Inside Our World</h1></div>
      <p className="text-sm text-slate-500 mt-2">Billboards, sponsored locations, events and challenges — reach thousands of engaged Nigerian players. Tell us what you need and we'll build a plan.</p>
      <form onSubmit={submit} className="mt-6 space-y-2.5">
        <input data-testid="lead-business" required placeholder="Business name" value={f.business_name} onChange={set("business_name")} className="input-dark" />
        <input data-testid="lead-contact" required placeholder="Contact person" value={f.contact_name} onChange={set("contact_name")} className="input-dark" />
        <input data-testid="lead-email" required type="email" placeholder="Email" value={f.email} onChange={set("email")} className="input-dark" />
        <div className="grid grid-cols-2 gap-2">
          <input placeholder="Phone / WhatsApp" value={f.phone} onChange={set("phone")} className="input-dark" />
          <input placeholder="Industry" value={f.industry} onChange={set("industry")} className="input-dark" />
        </div>
        <input placeholder="Website / social" value={f.website} onChange={set("website")} className="input-dark" />
        <input placeholder="Advertising objective" value={f.objective} onChange={set("objective")} className="input-dark" />
        <div className="grid grid-cols-2 gap-2">
          <input placeholder="Approx. budget" value={f.budget} onChange={set("budget")} className="input-dark" />
          <input placeholder="Desired campaign" value={f.desired_campaign} onChange={set("desired_campaign")} className="input-dark" />
        </div>
        <button data-testid="lead-submit" disabled={busy} className="w-full bg-[#FFD700] text-slate-900 font-bold py-3.5 rounded-xl disabled:opacity-50">{busy ? "Sending…" : "Talk to Sales"}</button>
      </form>
      <p className="mt-3 label-xs text-slate-400">Prefer self-service? <button onClick={() => nav("/advertise")} className="text-[#FFD700]">Open the advertiser portal →</button></p>
      <style>{`.input-dark{width:100%;background:#F1F5F9;border:1px solid #e2e8f0;border-radius:0.75rem;padding:0.7rem 0.95rem;color:#0F172A;font-size:0.875rem}.input-dark::placeholder{color:#94a3b8}.input-dark:focus{outline:none;border-color:#FFD700}`}</style>
    </div>
  );
}
